export class TableErrors {
	errors: { detailedErros: string[]; row: string }[];
	name: string;

	constructor(
		name: string,
		errors?: { detailedErros: string[]; row: string }[],
	) {
		this.name = name;

		this.errors = errors || [];
	}
}
